import React from 'react'
import { Layout } from './Layout'
import { useProps } from './useProps'

export const SurveysTable = () => {
  return <Layout {...useProps()} />
}
